import { FilterApi } from '../../utils/api';
import { LocalStorage } from '../../utils/localStorage';

//Listes des CPO pour les admins
export const getCPO = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setCpoData: React.Dispatch<React.SetStateAction<any[]>>,
  setCodeStatus: React.Dispatch<any>,
) => {
  setLoading(true);
  try {
    const response = await FilterApi.getCpos();
    setCpoData(response?.data.filter((d) => d !== null));
    setCodeStatus(response?.status);
  } catch (e) {
    console.log(e);
  }
  setLoading(false);
};

//quand le CPO est choisi par l'admin, on  affiche la liste de contrat rechargé
export const getContractAdmin = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setContractData: React.Dispatch<React.SetStateAction<never[]>>,
  setCodeStatus: React.Dispatch<any>,
  cpo: string,
) => {
  setLoading(true);
  try {
    const response = await FilterApi.getContract(cpo);
    setContractData(response?.data);
    setCodeStatus(response?.status);
  } catch (e) {
    console.log(e);
  }
  setLoading(false);
};

export const getContractCollectivity = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setContractData: React.Dispatch<React.SetStateAction<never[]>>,
  setCodeStatus: React.Dispatch<any>,
) => {
  setLoading(true);
  try {
    const response = await FilterApi.getUserContracts(
      LocalStorage.userMail.get(),
    );
    setContractData(response?.data);
    setCodeStatus(response?.status);
  } catch (e) {
    console.log(e);
  }
  setLoading(false);
};
